// import { deleteObject, ref } from 'firebase/storage';
// import { db, storage } from '../Firebase/firebaseConfig';
// import { collection, getDocs, query, orderBy, limit, DocumentSnapshot, startAfter, deleteDoc, doc, getDoc, setDoc } from 'firebase/firestore';
// import { ProductFormData } from '../Forms/schemas/productFormSchema';
// import { CareerFormValues } from '../Forms/CareerForm';



// export interface CareerFormData {
//   id: string;
//   jobTitle: string;
//   jobType: string;
//   jobLocation: string;
//   experienceLevel: string;
//   maxExperienceLevel:string;
//   jobDescription: string;
//   education: string;
//   noticePeriod: string;
//   salary: string;
//     extraFields?: { key: string; value: string }[];
//     industry: string;
//     generalDescription: string;
//   shortDescription: string;
//   description: string;
//   benefits: { iconUrl: string; key: string }[];
//   createdAt?: Date;
//     updatedAt?: Date;
// }



// export const getCareersFromFirebase = async (
//   itemLimit: number,
//   lastDoc?: DocumentSnapshot | null
// ): Promise<{ careers: CareerFormData[]; lastVisible: DocumentSnapshot | null }> => {
//   try {
     
//     const careerCollection = collection(db, 'careers');

//     const q = lastDoc
//       ? query(careerCollection, orderBy('__name__'), startAfter(lastDoc), limit(itemLimit))
//       : query(careerCollection, orderBy('__name__'), limit(itemLimit));

//     const querySnapshot = await getDocs(q);
//     const Careers: CareerFormData[] = [];

//     querySnapshot.forEach(doc => {
//       const data = doc.data();
//       Careers.push({
//         id: doc.id,
//         jobTitle: data.jobTitle || '',
//         experienceLevel: data.experienceLevel || '',
//         maxExperienceLevel: data.maxExperienceLevel || '',
//         jobType: data.jobType || '',
//         createdAt: data.createdAt?.toDate()?.toLocaleString() || '',
//         updatedAt: data.updatedAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
//         salary: data.salary || '',
//         shortDescription: data.shortDescription || '',
//         jobLocation: data.jobLocation || '',
//         jobDescription: data.jobDescription || '',
//         description: data.description || '',
//         benefits: Array.isArray(data.benefits)
//           ? data.benefits
//           : [],
//         industry: data.industry || '',
//         generalDescription: data.generalDescription || '',
//         extraFields: Array.isArray(data.extraFields) ? data.extraFields : [],
//         education: data.education || '',
//         noticePeriod: data.noticePeriod || ''
//       });
//     });

//     const lastVisible = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;

//     return { careers: Careers, lastVisible };
//   } catch (error) {
//     console.error("Error fetching news from Firebase:", error);
//     return { careers: [], lastVisible: null };
//   }
// };

// const getStoragePathFromUrl = (url: string): string | null => {
//   try {
//     const decodedUrl = decodeURIComponent(url.split('?')[0]);
//     const pathMatch = decodedUrl.match(/\/o\/(.+)$/);
//     return pathMatch ? pathMatch[1] : null;
//   } catch {
//     return null;
//   }
// };

// export const deleteCareerById = async (id: string): Promise<void> => {
//   try {
//     const careersRef = doc(db, 'careers', id);
//     const careersSnap = await getDoc(careersRef);

//     if (!careersSnap.exists()) {
//       throw new Error('careers not found');
//     }

//     const careersData = careersSnap.data();

//     const urls: string[] = [];

//     // if (careersData.base64Image) urls.push(careersData.base64Image);
//     if (Array.isArray(careersData.benefits)) urls.push(...careersData.benefits.map((benefit: { iconUrl: string }) => benefit.iconUrl).filter(Boolean));
//     // if (productsData.productsImagesFirst) urls.push(productsData.productsImagesFirst);
//     // if (productsData.productsImagesSecond) urls.push(productsData.productsImagesSecond);

//     const deletePromises = urls.map((url) => {
//       const path = getStoragePathFromUrl(url);
//       if (path) {
//         const imageRef = ref(storage, path);
//         return deleteObject(imageRef).catch((err) => {
//           console.warn(`Failed to delete image at ${path}:`, err);
//         });
//       }
//     });

//     await Promise.all(deletePromises);
//     await deleteDoc(careersRef);
//     console.log(`Careers ${id} and associated images deleted successfully.`);
//   } catch (error) {
//     console.error("Error deleting careers and its images:", error);
//     throw new Error("Failed to delete careers and its images");
//   }
// };


// export const createCareer = async (careerData: CareerFormValues): Promise<string> => {
//   try {
     
//     const careerRef = doc(collection(db, 'careers'));
//     await setDoc(careerRef, {
//       ...careerData,
//       createdAt: new Date(),
//       updatedAt: new Date(),
//     });
//     console.log(`Career ${careerRef.id} created successfully.`);
//     return careerRef.id;
//   } catch (error) {
//     console.error("Error creating career:", error);
//     throw new Error("Failed to create career");
//   }
// }
// export const updateCareer = async (id: string, careerData: CareerFormData): Promise<void> => {
//     try {
         
//         const careerRef = doc(db, 'careers', id);
//         await setDoc(careerRef, {
//         ...careerData,
//         updatedAt: new Date(),
//         }, { merge: true });
//         console.log(`Career ${id} updated successfully.`);
//     } catch (error) {
//         console.error("Error updating career:", error);
//         throw new Error("Failed to update career");
//     }
//     }   

//     export const getCareerById = async (id: string): Promise<CareerFormData | null> => {
//     try {
//         const careerRef = doc(db, 'careers', id);
//         const careerSnap = await getDoc(careerRef);

//         if (!careerSnap.exists()) {
//             console.warn(`Career with ID ${id} not found.`);
//             return null;
//         }

//         const data = careerSnap.data();
//         return {
//             id: careerSnap.id,
//             jobTitle: data.jobTitle || '',
//             experienceLevel: data.experienceLevel || '',
//             maxExperienceLevel: data.maxExperienceLevel || '',
//             jobType: data.jobType || '',
//             createdAt: data.createdAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
//             updatedAt: data.updatedAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
//             salary: data.salary || '',
//             shortDescription: data.shortDescription || '',
//             jobLocation: data.jobLocation || '',
//             jobDescription: data.jobDescription || '',
//             description: data.description || '',
//             benefits: Array.isArray(data.benefits) ? data.benefits : [],
//             industry: data.industry || '',
//             generalDescription: data.generalDescription || '',
//             extraFields: Array.isArray(data.extraFields) ? data.extraFields : [],
//             education: data.education || '',
//             noticePeriod: data.noticePeriod || ''
//         };
//     } catch (error) {
//         console.error("Error fetching career by ID:", error);
//         return null;
//     }
// }


// export default getCareersFromFirebase;

import { deleteObject, ref } from 'firebase/storage';
import { db, storage } from '../Firebase/firebaseConfig';
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  DocumentSnapshot,
  startAfter,
  deleteDoc,
  doc,
  getDoc,
  setDoc,
  where,
} from 'firebase/firestore';
import { ProductFormData } from '../Forms/schemas/productFormSchema';
import { CareerFormValues } from '../Forms/CareerForm';

export interface CareerFormData {
  id: string;
  jobTitle: string;
  jobType: string;
  jobLocation: string;
  experienceLevel: string;
  maxExperienceLevel: string;
  jobDescription: string;
  education: string;
  noticePeriod: string;
  salary: string;
  extraFields?: { key: string; value: string }[];
  industry: string;
  generalDescription: string;
  shortDescription: string;
  description: string;
  benefits: { iconUrl: string; key: string }[];
  createdAt?: Date;
  updatedAt?: Date;
}

interface Filters {
  jobType?: string;
  experienceLevel?: number;
}

export const getCareersFromFirebase = async (
  itemLimit: number,
  lastDoc?: DocumentSnapshot | null,
  filters?: Filters
): Promise<{ careers: CareerFormData[]; lastVisible: DocumentSnapshot | null }> => {
  try {
    const careerCollection = collection(db, 'careers');
    const constraints: any[] = [];

    //  Firebase filtering based on jobType and experienceLevel
    if (filters?.jobType) {
      constraints.push(where('jobType', '==', filters.jobType));
    }
    // if (filters?.experienceLevel !== undefined && filters.experienceLevel !== null) {
    //   constraints.push(where('experienceLevel', '>=', filters.experienceLevel));
    // }
 

    if (filters?.experienceLevel) {
      constraints.push(where('experienceLevel', '==', filters.experienceLevel));
    }

    constraints.push(orderBy('__name__'));

    if (lastDoc) {
      constraints.push(startAfter(lastDoc));
    }

    constraints.push(limit(itemLimit));

    const q = query(careerCollection, ...constraints);
    const querySnapshot = await getDocs(q);

    const Careers: CareerFormData[] = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      Careers.push({
        id: doc.id,
        jobTitle: data.jobTitle || '',
        experienceLevel: data.experienceLevel || '',
        maxExperienceLevel: data.maxExperienceLevel || '',
        jobType: data.jobType || '',
        createdAt: data.createdAt?.toDate()?.toLocaleString() || '',
        updatedAt: data.updatedAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
        salary: data.salary || '',
        shortDescription: data.shortDescription || '',
        jobLocation: data.jobLocation || '',
        jobDescription: data.jobDescription || '',
        description: data.description || '',
        benefits: Array.isArray(data.benefits) ? data.benefits : [],
        industry: data.industry || '',
        generalDescription: data.generalDescription || '',
        extraFields: Array.isArray(data.extraFields) ? data.extraFields : [],
        education: data.education || '',
        noticePeriod: data.noticePeriod || '',
      });
    });

    const lastVisible =
      querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;

    return { careers: Careers, lastVisible };
  } catch (error) {
    console.error('Error fetching careers from Firebase:', error);
    return { careers: [], lastVisible: null };
  }
};

const getStoragePathFromUrl = (url: string): string | null => {
  try {
    const decodedUrl = decodeURIComponent(url.split('?')[0]);
    const pathMatch = decodedUrl.match(/\/o\/(.+)$/);
    return pathMatch ? pathMatch[1] : null;
  } catch {
    return null;
  }
};

export const deleteCareerById = async (id: string): Promise<void> => {
  try {
    const careersRef = doc(db, 'careers', id);
    const careersSnap = await getDoc(careersRef);

    if (!careersSnap.exists()) {
      throw new Error('careers not found');
    }

    const careersData = careersSnap.data();

    const urls: string[] = [];
    if (Array.isArray(careersData.benefits)) {
      urls.push(...careersData.benefits.map((benefit: { iconUrl: string }) => benefit.iconUrl).filter(Boolean));
    }

    const deletePromises = urls.map((url) => {
      const path = getStoragePathFromUrl(url);
      if (path) {
        const imageRef = ref(storage, path);
        return deleteObject(imageRef).catch((err) => {
          console.warn(`Failed to delete image at ${path}:`, err);
        });
      }
    });

    await Promise.all(deletePromises);
    await deleteDoc(careersRef);
    console.log(`Careers ${id} and associated images deleted successfully.`);
  } catch (error) {
    console.error('Error deleting careers and its images:', error);
    throw new Error('Failed to delete careers and its images');
  }
};

export const createCareer = async (careerData: CareerFormValues): Promise<string> => {
  try {
    const careerRef = doc(collection(db, 'careers'));
    await setDoc(careerRef, {
      ...careerData,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    console.log(`Career ${careerRef.id} created successfully.`);
    return careerRef.id;
  } catch (error) {
    console.error('Error creating career:', error);
    throw new Error('Failed to create career');
  }
};

export const updateCareer = async (id: string, careerData: CareerFormData): Promise<void> => {
  try {
    const careerRef = doc(db, 'careers', id);
    await setDoc(
      careerRef,
      {
        ...careerData,
        updatedAt: new Date(),
      },
      { merge: true }
    );
    console.log(`Career ${id} updated successfully.`);
  } catch (error) {
    console.error('Error updating career:', error);
    throw new Error('Failed to update career');
  }
};

export const getCareerById = async (id: string): Promise<CareerFormData | null> => {
  try {
    const careerRef = doc(db, 'careers', id);
    const careerSnap = await getDoc(careerRef);

    if (!careerSnap.exists()) {
      console.warn(`Career with ID ${id} not found.`);
      return null;
    }

    const data = careerSnap.data();
    return {
      id: careerSnap.id,
      jobTitle: data.jobTitle || '',
      experienceLevel: data.experienceLevel || '',
      maxExperienceLevel: data.maxExperienceLevel || '',
      jobType: data.jobType || '',
      createdAt: data.createdAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
      updatedAt: data.updatedAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(),
      salary: data.salary || '',
      shortDescription: data.shortDescription || '',
      jobLocation: data.jobLocation || '',
      jobDescription: data.jobDescription || '',
      description: data.description || '',
      benefits: Array.isArray(data.benefits) ? data.benefits : [],
      industry: data.industry || '',
      generalDescription: data.generalDescription || '',
      extraFields: Array.isArray(data.extraFields) ? data.extraFields : [],
      education: data.education || '',
      noticePeriod: data.noticePeriod || '',
    };
  } catch (error) {
    console.error('Error fetching career by ID:', error);
    return null;
  }
};

export default getCareersFromFirebase;
